export default __webpack_public_path__ + "static/media/BE_Sciences_RGB_Icon.5471fd3c.svg";